import { useEffect, useState } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import InitialApp from './components/InitialApp/InitialApp';
import MUIProviderTemplate from './appTemplates/MUIProviderTemplate/MUIProviderTemplate';
import buildROUTES from './constants/routes';
import BASE_PATH from './constants/path';
import '@hid-galaxy-ui/galaxy-css/galaxy.css';
import './App.css';

import {
  isOnlyProjectTokenExistFromUrl,
  isQueryParamsExist,
} from './utils/functions';
import { Notification } from '@hid-galaxy-ui/galaxy-react';
import { NOTIFICATION_AUTO_CLOSE_DURATION } from './constants/common';
import RouteComponent from './RouteComponent';
import './translations/i18n';
import { useTranslation } from 'react-i18next';

export const history = createBrowserHistory({
  // @ts-ignore
  basename: BASE_PATH,
  forceRefresh: true,
});

export interface IAppProps {
  toasts: any;
  setToasts: any;
}

const App = () => {
  const [routes, setRoutes] = useState<JSX.Element[]>([]);
  const [toasts, setToasts] = useState([]);
  const { i18n } = useTranslation();

  useEffect(() => {
    const routesComponents = buildROUTES().map((route) => {
      const { component, mainTemplate } = route;
      if (route.guard) {
        return (
          <Route
            key={route.path}
            exact
            path={route.path}
            render={(props) => (
              <RouteComponent
                component={component}
                mainTemplate={mainTemplate}
                isProtected={route.isProtected}
                {...props}
                toasts={toasts}
                setToasts={setToasts}
              />
            )}
          />
        );
        // TODO: To implement guard functionality

        // return (
        //   <Route
        //     key={route.path}
        //     exact
        //     path={route.path}
        //     render={(props) => (
        //       <route.guard {...props} component={component} toasts={toasts} setToasts={setToasts} />
        //     )}
        //   />
        // );
      }
      return (
        <Route
          key={route.path}
          exact
          path={route.path}
          render={(props) => (
            <RouteComponent
              component={component}
              isProtected={route.isProtected}
              mainTemplate={mainTemplate}
              {...props}
              toasts={toasts}
              setToasts={setToasts}
            />
          )}
        />
      );
    });

    setRoutes(routesComponents);
  }, []);

  const renderComponents = () => {
    return (
      <>
        {/* <TranslationsProvider>  */}
        <MUIProviderTemplate>
          <Switch>{routes}</Switch>

          <Notification
            toasts={toasts}
            setToasts={setToasts}
            autoClose={NOTIFICATION_AUTO_CLOSE_DURATION}
          />
        </MUIProviderTemplate>
        {/* </TranslationsProvider> */}
      </>
    );
  };

  return (
    <BrowserRouter history={history}>
      {isQueryParamsExist() && !isOnlyProjectTokenExistFromUrl() ? (
        <InitialApp>{renderComponents()}</InitialApp>
      ) : (
        renderComponents()
      )}
    </BrowserRouter>
  );
};

export default App;
